module.exports = __webpack_public_path__ + "static/media/4@3x.eb265f6a.png";